const casos = {
    "205": {
        "id":"205",
        "state":"ok",
        "thum":"portada.png",
        "skills":['Figma','Maze','Jira', 'Design thinking', 'User test'],
        "imgs":{
            "portada":"0",
            "solucion":['3','4']
        },
        "es": {
            "proyecto": "Listas y cotizaciones",
            "bajada": "Cómo aplicar las cotizaciones de una forma intuitiva para los usuarios.",
            "descripcion": "Con el objetivo de fidelizar a los usuarios especialistas de sódimac, participé en el diseño de un flujo de listas que permitiera generar y guardar cotizaciones.",
            "contexto": {
                "p1":{
                    "texto":"En un plan para fidelizar y llegar de mejor forma a los usuarios especialistas de Sodimac, se decide implementar una nueva funcionalidad que consistía en crear cotizaciones desde la web y, en Chile, mantenerlas disponibles por 5 días."
                },
                "p2":{
                    "texto":"El objetivo inicial fue aumentar las compras vía web por parte del usuario especialista. Si bien la compra de este tipo de usuarios es muy alta, se concentra principalmente en tiendas y la idea era poder captarlos en nuestros canales digitales para generar ventas y potenciar otros servicios digitales. Me tocó, como diseñador UX/UI, investigar y diseñar la solución, planteando los puntos de mejora y el mejor camino de acción."
                }
            },
            "Investigacion": {
                "p1": {
                    "texto":"Como base de investigación usé Design Thinking e implementé en sus etapas reuniones con stakeholders, reuniones con UX researchers, entrevistas en tienda (con usuarios y monitores del círculo de especialistas) y un benchmark competitivo para analizar cómo actores nacionales e internacionales solucionaban esta herramienta."},
                "p2": {
                    "texto":"Los principales hallazgos de la investigación fueron: a-. Los usuarios especialistas presentaban un nivel de digitalización muy bajo. b-.Los usuarios recurrentes utilizaban el carrito de compras como herramienta de cotización informal, seleccionando productos solo para revisar el total aproximado. c-. Debido a restricciones técnicas del proyecto (no modificar el flujo del carrito), se descartó una solución integrada directamente en el checkout. d-. El benchmark (build.com, Home Depot, Amazon, Lowe’s) mostró una tendencia clara hacia el uso de 'Listas' para agrupar productos y generar presupuestos."
                },
                "p3": {
                    "texto":"En base a la información recolectada, decidimos cambiar el enfoque hacia 'Listas con cotizaciones' en lugar de una funcionalidad aislada que no estábamos preparados para explotar."
                }
            },
            "solucion": {
                "p1": {
                    "texto":"La primera definición fue quiénes podrían crear listas, concluyendo que usuarios logeados no tendrían restricción en la creación de listas, mientras que usuarios no logeados, primero, tendrían que iniciar sesión. Esto ayuda a mejorar el flujo del usuario y, por otro lado, contribuye a otro objetivo del sitio: fomentar la naveción con usuarios registrados."},
                "p2": {
                    "texto":"La segunda fue definir los punto de entrada a crear, editar y agregar productos a una lista. Esto era importante poque permiía de finir los equipos involucrados en el proyecto y la distribución de las tareas en el proyecto.",
                    /* "img": ["ruta_imagen_1", "ruta_imagen_2"] */
                },
                "p3": {
                    "texto":"Los puntos de entrada serían: a-. PLP (product list page): En esta página podrían accionar el panel para crear y/o guardar prodcutos en una lista. b-.PDP (product detail page): Lo mismo que en PLP. c-. Mis listas (My account): en esta sección se podría crear, editar y eliminar listas.",
                    /* "img": ["ruta_imagen_1", "ruta_imagen_2"] */
                },
                "p4": {
                    "texto":"Luego de las definiciones, lo importante era cómo dejar en claro que el sitio tenía disponible la opción para crear y administrar listas. Una vez este paso estuvo listo, trabajé sobre la encontrabilidad de las cotizaciones y su uso.",
                    /* "img": ["ruta_imagen_1", "ruta_imagen_2"] */
                },
                "p5": {
                    "texto":"Con estas definiciones listas, comencé trabajar sobre los flujos, utilizando los componentes del design system, cosa de pasar a un diseño 'final' más rápido y comenzar la etapa de test lo antes posible."
                }
            },
            "metricas":{
                "m1":{
                    "call":"2",
                    "subtitle":"Iteraciones con usuarios",
                    "description":"Test con usuarios moderadas y no moderadas para refinar la solución.",
                },
                "m2":{
                    "call":"Sobre 90%",
                    "subtitle":"Tasa de éxito segunda iteración.",
                    "description":"Se logró una versión más pulida del flujo y una mejor comunicación en las pantallas.",
                },
                "m3":{
                    "call":"Escalabilidad",
                    "subtitle":"MVP preparado para algo mayor",
                    "description":"Este MVP se pensó para escalar a una solución que pueda involucrar a constructores, clientes y colaboradores.",
                },
            },
            "aprendizajes": {
                "p1":{
                    "texto":"En este proyecto se puso en relieve lo importante que es estar alineados con el equipo de research. Su información fue clave para enfocar el proyecto en una dirección diferente y que, según nuestros objetivos, nos permitiera entragar una solución más intuitiva y alineada a la experiencia estandar actual."
                }
            },
            "cta":"Leer caso"
        },
        "en": {
            "proyecto": "Lists and Quotations",
            "bajada": "How to implement quotations intuitively for users.",
            "descripcion": "With the goal of increasing loyalty among Sodimac's specialist users, I participated in the design of a list flow that allowed creating and savig ciotations.",
            "contexto": {
                "p1": {
                    "texto":"As part of a plan to build loyalty and better reach Sodimac's specialist users, it was decided to implement a new feature consisting of creating quotations from the website and, specifically for Chile, keeping them available for 5 days."
                },
                "p2": {
                    "texto":"The initial objective was to increase online purchases by specialist users. Although their purchase volume is very high, it is mainly concentrated in physical stores; the idea was to capture them through our digital channels to drive sales and promote other digital services. As a UX/UI designer, I was responsible for researching and designing the solution, identifying pain points and the best course of action."
                }
            },
            "Investigacion": {
                "p1": {
                    "texto": "I used Design Thinking as my research foundation, implementing stakeholder meetings, sessions with UX researchers, in-store interviews (with users and specialist circle monitors), and a competitive benchmark to analyze how national and international players addressed this tool."
                },
                "p2": {
                    "texto": "The main research findings were: a-. Specialist users showed a very low level of digitalization. b-. Recurring users were using the shopping cart as an informal quotation tool, selecting products just to check the approximate total. c-. Due to technical project constraints (not modifying the cart flow), a solution integrated directly into the checkout was ruled out. d-. The benchmark (build.com, Home Depot, Amazon, Lowe’s) showed a clear trend toward using 'Lists' to group products and generate quotes."
                },
                "p3": {
                    "texto": "Based on the gathered insights, we decided to shift the focus toward 'Lists with Quotations' instead of a standalone feature that we weren't technically prepared to fully leverage."
                }
            },
            "solucion": {
                "p1": {
                    "texto": "The first definition was determining who could create lists; we concluded that logged-in users would have no restrictions, while guest users would first need to log in. This helps improve the user flow and contributes to another site objective: encouraging browsing by registered users."
                },
                "p2": {
                    "texto": "The second step was defining the entry points to create, edit, and add products to a list. This was crucial as it allowed us to define the teams involved and the distribution of tasks throughout the project."
                },
                "p3": {
                    "texto": "The entry points would be: a-. PLP (product list page): On this page, users could trigger the panel to create and/or save products to a list. b-. PDP (product detail page): Same as PLP. c-. My lists (My account): in this section, users could create, edit, and delete lists."
                },
                "p4": {
                    "texto": "After the definitions, the focus shifted to clearly communicating that the site offered the option to create and manage lists. Once this step was complete, I worked on the findability and usability of the quotations themselves."
                },
                "p5": {
                    "texto": "With these definitions ready, I began working on the flows, utilizing the design system components to move to a 'final' design more quickly and start the testing phase as soon as possible."
                }
            },
            "metricas": {
                "m1": {
                    "call": "2",
                    "subtitle": "User Iterations",
                    "description": "Moderated and unmoderated user testing sessions conducted to refine the solution."
                },
                "m2": {
                    "call": "Over 90%",
                    "subtitle": "Success Rate",
                    "description": "Achieved a more polished flow and clearer screen communication by the second iteration."
                },
                "m3": {
                    "call": "Scalability",
                    "subtitle": "Future-Proof MVP",
                    "description": "Designed as a scalable MVP built to eventually integrate contractors, clients, and internal teams."
                }
            },
            "aprendizajes": {
                "p1": {
                    "texto": "This project highlighted the critical importance of being aligned with the research team. Their insights were key to pivoting the project's direction, allowing us to deliver a more intuitive solution that met our objectives and aligned with current industry-standard experiences."
                }
            },
            "cta": "Read case study"
        },
    },
    "215": {
        "id": "215",
        "state":"ok",
        "thum": "portada.png",
        "skills":['Figma','Maze','Jira', 'Design thinking', 'Design system'],
        "imgs":{
            "portada":"contexto",
            "solucion":['investigacion','solucion_1','solucion_2','solucion_3']
        },
        "es": {
            "proyecto": "ICB Food Service",
            "bajada": "Rediseño y actualización al retail actual.",
            "descripcion": "Rediseño de interfaz y nuevos componentes para actualizar el aplicativo PIA Market de ICB Food Service en sus versión mobile, con especial atención en el proceso de compra, carro y checkout.",
            "contexto": {
                "p1":{
                    "texto":"PIA Market, un aplicativo HORECA de ICB Food Service, necesitaba actualizarse a los estándares de retail actual para mejorar su experiencia B2B y prepararse para una próxima salida a B2C."
                },
                "p2":{
                    "texto":"El primer objetivo fue actualizar la estética y mitigar fricciones detectadas en los flujos de búsqueda, adición al carro y pago. Como diseñador UX/UI, realicé un benchmark comparativo entre referentes B2B y los principales retailers de alimentos (Alvi, Jumbo, etc.) para definir lineamientos de usabilidad sin comprometer las funcionalidades críticas del sitio."
                },
            },
            "Investigacion": {
                "p1":{
                    "texto":"Implementamos Design Thinking con reuniones de stakeholders y un benchmark visual profundo."
                },
                "p2":{
                    "texto":"Los resultados clave fueron: a-. Versión mobile obsoleta. b-. Home sin jerarquía comercial. c-. Complejidad en precios (hasta 3 precios por producto con descuentos y unidades de medida variables). d-. PLP y PDP con baja intuitividad y jerarquía visual. e-. Checkout confuso en opciones de entrega."},
                "p3":{
                    "texto":"Se determinó la necesidad de un Home orientado a la conversión con accesos directos a secciones estratégicas."
                }
            },
            "solucion": {
                "p1": {
                    "texto":"Lo primero fue definir un diseño limpio y simple, favoreciendo la conversión y la modularidad, permitiendo que el sitio crezca sin requerir rediseños estructurales constantes."},
                "p2": {
                    "texto":"Se optimizó la arquitectura de información en las fichas de producto (PDP) para clarificar la visualización de los múltiples precios y unidades de medida, reduciendo la carga cognitiva del usuario.",
                    /* "img": ["ruta_diseno_1", "ruta_diseno_2"] */
                },
            },
            "metricas":{
                "m1":{
                    "call":"3",
                    "subtitle":"Flujos testeados",
                    "description":"Test no moderados coordinados junto con negocio para apuntar a los usuarios ICB.",
                },
                "m2":{
                    "call":"85%",
                    "subtitle":"Tasa de éxito",
                    "description":"Se logró una comunicación adecuada en los flujos críticos del sitio. Esto ayudó a que los usuarios lograran completar la tareas sin problemas.",
                },
                "m3":{
                    "call":"Modernización",
                    "subtitle":"De cara al usuarios B2C",
                    "description":"Se logró crear una versión adecuada para usuarios B2C y B2B, tomando en cuenta que los usuarios ICB, hasta diciembre del 2025, eran solo empresas.",
                },
                "m4":{
                    "call":"Release",
                    "subtitle":"Desde Noviembre 2025",
                    "description":"Se trabajó en sprints que consideraban salidas semanales desde noviembre del 2025 (inicio del proyecto en octubre del mismo año), cumpliendose gracias a la coordinación entre equipo de rediseño y desarrollo.",
                },
            },
            "aprendizajes": {
                "p1":{
                    "texto":"Entendí cómo gestionar la complejidad de datos B2B (múltiples precios y reglas de negocio) transformándolos en una interfaz simplificada apta para un usuario final B2C."
                }
            },
            "cta":"Leer caso"
        },
        "en": {
            "proyecto": "ICB Food Service",
            "bajada": "Redesign and update to modern retail standards.",
            "descripcion": "Interface redesign and new components to update the ICB Food Service PIA Market application for its mobile version, with a special focus on the purchasing process, cart, and checkout.",
            "contexto": {
                "p1": {
                    "texto": "PIA Market, a HORECA (Hotel/Restaurant/Catering) application by ICB Food Service, needed to be updated to current retail standards to improve its B2B experience and prepare for a future B2C launch."
                },
                "p2": {
                    "texto": "The primary goal was to refresh the aesthetics and mitigate friction detected in the search, add-to-cart, and payment flows. As a UX/UI designer, I conducted a competitive benchmark between B2B leaders and major food retailers (Alvi, Jumbo, etc.) to define usability guidelines without compromising critical site functionalities."
                }
            },
            "Investigacion": {
                "p1": {
                    "texto": "We implemented Design Thinking, including stakeholder meetings and an in-depth visual benchmark."
                },
                "p2": {
                    "texto": "The key findings were: a-. Obsolete mobile version. b-. Home page lacking commercial hierarchy. c-. Complex pricing (up to 3 prices per product with discounts and variable units of measurement). d-. PLP and PDP with low intuitiveness and poor visual hierarchy. e-. Confusing checkout regarding delivery options."
                },
                "p3": {
                    "texto": "The need for a conversion-oriented Home page with direct access to strategic sections was identified."
                }
            },
            "solucion": {
                "p1": {
                    "texto": "The first step was defining a clean and simple design, favoring conversion and modularity, allowing the site to grow without requiring constant structural redesigns."
                },
                "p2": {
                    "texto": "The information architecture of the product detail pages (PDP) was optimized to clarify the visualization of multiple prices and units of measurement, reducing the user's cognitive load."
                }
            },
            "metricas": {
                "m1": {
                    "call": "3",
                    "subtitle": "Tested Flows",
                    "description": "Unmoderated tests coordinated with stakeholders to target specific ICB user segments."
                },
                "m2": {
                    "call": "85%",
                    "subtitle": "Success Rate",
                    "description": "Achieved effective communication across critical site flows, allowing users to complete tasks seamlessly."
                },
                "m3": {
                    "call": "Modernization",
                    "subtitle": "B2C & B2B Integration",
                    "description": "Developed a unified experience for both B2C and B2B users, expanding ICB's reach beyond its traditional corporate-only model."
                },
                "m4": {
                    "call": "Launch",
                    "subtitle": "Since November 2025",
                    "description": "Executed weekly releases through agile sprints, ensuring on-time delivery via close coordination between design and dev teams."
                }
            },
            "aprendizajes": {
                "p1":{
                    "texto":"I learned how to manage the complexity of B2B data (multiple prices and business rules) by transforming them into a simplified interface suitable for a B2C end-user."}
            },
            "cta": "Read case study"
        }
    }
}

export default casos;
